import styled from 'styled-components';

export const DesktopHeaderWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  width: 100%;
  min-height: 80px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    display: column;
    justify-content: flex-end;
  }
`;

export const LeftColumnWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  & > a {
    align-self: center;
  }
`;

export const MenuListWrapper = styled.div`
  display: flex;
  align-items: stretch;
`;

export const IconRectangle = styled.div`
  width: 1px;
  height: 32px;
  background: ${({ theme }) => theme.palette.whiteAlpha300};
  color: ${({ theme }) => theme.palette.white};
  margin: 0px 20px 0px 40px;
  align-self: center;
`;

export const RightColumnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MenuContent = styled.div`
  display: flex;
  display: inline-flex;
  align-items: center;
  position: relative;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    display: column;
    justify-content: flex-end;
  }
`;

export const Rectangle = styled.div`
  width: 1px;
  height: 24px;
  background: ${({ theme }) => theme.palette.whiteAlpha300};
  margin: 0 16px 0px 16px;
  color: ${({ theme }) => theme.palette.white};
`;
